import React, { FC, useCallback } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import useUserVerification from 'hooks/use-user-verification';
import { toast } from 'utils/toast';

const Container = styled.div`
  margin: 2rem auto 1rem auto;
  text-align: center;
`;

const Instructions = styled.div`
  margin-bottom: 2rem;
`;

const Button = styled(ActionButton)`
  margin: auto;
`;

const UserVerification: FC = () => {
  const { formatMessage } = useIntl();
  const { sendVerificationEmail, loading } = useUserVerification();
  const onVerify = useCallback(
    async event => {
      event.preventDefault();
      await sendVerificationEmail();
      toast.success(formatMessage({ id: 'emailVerificationSent' }));
    },
    [formatMessage, sendVerificationEmail]
  );
  return (
    <Container data-testid="user-verification">
      <Instructions>
        {formatMessage({
          id: 'verifyYourEmailInstructions',
        })}
      </Instructions>
      <Button isLoading={loading} onClick={onVerify} data-testid="user-verification-verify-button">
        {formatMessage({
          id: 'verifyYourEmail',
        })}
      </Button>
    </Container>
  );
};

export default UserVerification;
